export default __webpack_public_path__ + "static/media/salesImg.ed1afd3f.svg";